const SCROLL_PREFIX = "ac-shop-scroll:";

export type ShopDetailNavState = {
  id: number;
  type: "service" | "product";
  returnTo?: "/services" | "/products";
  name?: string;
  price?: unknown;
};

export function saveListScroll(returnPath: string) {
  try {
    sessionStorage.setItem(
      `${SCROLL_PREFIX}${returnPath}`,
      String(window.scrollY)
    );
  } catch {
    /* ignore */
  }
}

export function consumeListScroll(returnPath: string): number | null {
  try {
    const raw = sessionStorage.getItem(`${SCROLL_PREFIX}${returnPath}`);
    sessionStorage.removeItem(`${SCROLL_PREFIX}${returnPath}`);
    if (raw == null) return null;
    const y = Number(raw);
    return Number.isFinite(y) ? y : null;
  } catch {
    return null;
  }
}

export function buildDetailNavState(
  payload: ShopDetailNavState
): ShopDetailNavState {
  if (payload.returnTo) {
    saveListScroll(payload.returnTo);
  }
  return payload;
}
